import React from 'react'
import Modal from 'react-modal'

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    background: 'transparent',
    padding: '0',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    zIndex: 2000,
  },
}

const LandingWelcomeModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      portalClassName="landingWelcome"
      contentLabel="Welcome to FamConnect26"
      ariaHideApp={false}
    >
      <div className="modal-content landing-welcome-modal-content">
        <div className="modal-body landing-welcome-modal-body">
          {/* <h5 className="landing-welcome-modal-title">About FamConnect26</h5> */}
          <p className="landing-welcome-modal-text">
            Take time to read the information provided on this page and the FAQ to get a clearer picture of what
            the app is all about, which can help as you navigate through this web app.
          </p>
        </div>
        <div className="modal-footer landing-welcome-modal-footer">
          <button type="button" className="btn btn-cancel" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default LandingWelcomeModal
